import { useAppDispatch, useAppSelector } from "@/app/hooks";
import type { ColorOptions, SizeOptions } from "@/types";
import { ActionIcon, CheckIcon, ColorSwatch, Divider, Drawer, Group, Stack, Text } from "@mantine/core";
import { IconMinus } from "@tabler/icons-react";
import { colorSelected, setSelectedColor, setSelectedSize, sizeSelected } from "./drawingSlice";

export interface DrawingDrawerProps {
    title: string;
}

// Cyan is reserved for saved parcels, so it is not offered for drawings.
const DRAWING_COLORS: { color: ColorOptions; checkColor: string }[] = [
    { color: 'blue', checkColor: 'white' },
    { color: 'red', checkColor: 'white' },
    { color: 'green', checkColor: 'white' },
    { color: 'yellow', checkColor: 'black' },
    { color: 'hotpink', checkColor: 'white' },
];
const DRAWING_SIZES: { size: SizeOptions; label: string; stroke: number }[] = [
    { size: 'small', label: 'Small', stroke: 3 },
    { size: 'medium', label: 'Medium', stroke: 5 },
    { size: 'large', label: 'Large', stroke: 7 },
];

const DrawingDrawer: React.FC<DrawingDrawerProps> = ({ title }) => {
    const dispatch = useAppDispatch();
    const currentColorSelected = useAppSelector(colorSelected)
    const currentSizeSelected = useAppSelector(sizeSelected)

    return (
        <Drawer
            styles={{ overlay: { display: "none" }, content: { borderRadius: '10px 10px 0 0' }, body: { paddingLeft: 10, paddingRight: 10, paddingBottom: 10 }, title: { width: '100%' }, header: { paddingTop: 5, paddingBottom: 5 } }}
            opened={true}
            onClose={() => {}}
            padding={10}
            position="bottom"
            withCloseButton={false}
            size='33vh'
            trapFocus={false}
            title={
                <Stack gap={0}>
                    {title}
                    <Divider mt={5} my={0} size='sm' />
                </Stack>
            }>
                <Stack gap={10}>
                    <Text>Color</Text>
                    <Group align="center" justify="center">
                        {DRAWING_COLORS.map(({ color, checkColor }) => (
                            <ColorSwatch key={color} color={color} onClick={() => dispatch(setSelectedColor(color))} aria-label={color}>
                                {currentColorSelected === color && <CheckIcon color={checkColor} size={15} />}
                            </ColorSwatch>
                        ))}
                    </Group>
                    <Text>Weight</Text>
                    <Group align="center" justify="center">
                        {DRAWING_SIZES.map(({ size, label, stroke }) => (
                            <ActionIcon key={size} title={label} aria-label={label} onClick={() => dispatch(setSelectedSize(size))} color="black" variant={currentSizeSelected === size ? 'outline' : 'transparent'}>
                                <IconMinus color='black' stroke={stroke} />
                            </ActionIcon>
                        ))}
                    </Group>
                </Stack>
        </Drawer>
    );
}

export default DrawingDrawer;
